import CommonText from 'common/components/entities/TextNew/ui/TextUi'
import { TextInterface } from 'common/types/entities/TextInterface'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import React from 'react'
import { useCalculateHeadingTypography } from 'src/publisher/shared/hooks/use-calculate-heading-typography'
import { useThemeColor } from 'src/publisher/shared/hooks/use-theme-color'
import { usePopupOpenerRef } from '../../hooks/use-popup-opener-ref'
import { useDelay } from '../../hooks/useDelay'

const Headline = ({ entity }: { entity: TextInterface }) => {
  const ref = usePopupOpenerRef()
  const isVisible = useDelay(entity.delay)

  const {
    text: { headingTextColor, headingBackgroundColor },
    links: {
      linkTextColor,
      linkHoveredBackgroundColor,
      linkPressedBackgroundColor,
    },
  } = useThemeColor()
  const {
    calculatedFontSize,
    calculatedLineHeight,
    calculatedTextAlign,
    calculatedLetterSpacing,
    calculatedFontFamily,
    calculatedFontStyle,
    calculatedFontWeight,
  } = useCalculateHeadingTypography({
    fontSize: entity.fontSize,
    mobileFontSize: entity.mobileFontSize,
    lineHeight: entity.lineHeight,
    mobileLineHeight: entity.mobileLineHeight,
    textAlign: entity.textAlign,
    mobileTextAlign: entity.mobileTextAlign,
    letterSpacing: entity.letterSpacing,
    mobileLetterSpacing: entity.mobileLetterSpacing,
    fontFamily: entity.fontFamily,
    mobileFontFamily: entity.mobileFontFamily,
    fontWeight: entity.fontWeight,
    mobileFontWeight: entity.mobileFontWeight,
    fontStyle: entity.fontStyle,
    mobileFontStyle: entity.mobileFontStyle,
  })

  return isVisible ? (
    <StyleWrapper
      appearance={entity.appearance}
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
    >
      <CommonText
        id={entity.htmlAttrId}
        linkColor={linkTextColor}
        fontSize={calculatedFontSize.desktop}
        mobileFontSize={calculatedFontSize.mobile}
        lineHeight={calculatedLineHeight.desktop}
        mobileLineHeight={calculatedLineHeight.mobile}
        color={headingTextColor}
        fontFamily={calculatedFontFamily.desktop}
        mobileFontFamily={calculatedFontFamily.mobile}
        fontStyle={calculatedFontStyle.desktop}
        mobileFontStyle={calculatedFontStyle.mobile}
        fontWeight={calculatedFontWeight.desktop}
        mobileFontWeight={calculatedFontWeight.mobile}
        padding={entity.padding}
        mobilePadding={entity.mobilePadding}
        textAlign={calculatedTextAlign.desktop}
        mobileTextAlign={calculatedTextAlign.mobile}
        backgroundColor={entity.backgroundColor || headingBackgroundColor}
        mobileBackgroundColor={
          entity.mobileBackgroundColor || headingBackgroundColor
        }
        letterSpacing={calculatedLetterSpacing.desktop}
        mobileLetterSpacing={calculatedLetterSpacing.mobile}
        linkHover={{ color: linkHoveredBackgroundColor }}
        linkActive={{ color: linkPressedBackgroundColor }}
        dangerouslySetInnerHTML={{
          __html: entity.content || entity.html || '',
        }}
        ref={ref}
        enableHeadings
      />
    </StyleWrapper>
  ) : (
    <div />
  )
}

export default Headline
